import * as React from 'react';
import {Box, Skeleton, Typography} from "@mui/material";

export interface DashboardPanelProps {
    title: string
    ready: boolean
    titleAction?: React.ReactNode
    skeletonHeight?: number | string
    height?: number | string
    children?: React.ReactNode
}


export default function DashboardPanel({title, ready, titleAction, skeletonHeight = 300, height, children} : DashboardPanelProps) {

    if (!ready) {
        return <Skeleton height={skeletonHeight} variant="rectangular" sx={{borderRadius: 2}}/>
    }

    return (
        <Box bgcolor="primary.light" height={height} sx={{position: 'relative', borderRadius: 2, overflow: 'hidden'}}>
            <Box bgcolor="secondary.light"
                 color="secondary.contrastText"
                 sx={{position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', px: 2, py: 1}}
            >
                <Typography variant="body1" fontWeight="bold" align="left" noWrap>{title}</Typography>
                {titleAction && (
                    <Box sx={{position: 'absolute', top: 4, bottom: 4, right: 4, display: 'flex', alignItems: 'center'}}>
                        {titleAction}
                    </Box>
                )}
            </Box>
            {children}
        </Box>
    );
}
